'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n'], ['\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n']);

var _pickToolTipName = require('./UIAvatarDisplay/pickToolTipName');

var _pickToolTipName2 = _interopRequireDefault(_pickToolTipName);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIAvatarRequest = require('./UIAvatarRequest');

var _UIAvatarRequest2 = _interopRequireDefault(_UIAvatarRequest);

var _Constants = require('./Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AvatarListWrapper = (0, _styledComponents2.default)('div').withConfig({
  displayName: 'UIAvatarMultiOrSingle__AvatarListWrapper'
})(_templateObject);

var UIAvatarMultiOrSingle = function (_Component) {
  _inherits(UIAvatarMultiOrSingle, _Component);

  function UIAvatarMultiOrSingle() {
    _classCallCheck(this, UIAvatarMultiOrSingle);

    return _possibleConstructorReturn(this, (UIAvatarMultiOrSingle.__proto__ || Object.getPrototypeOf(UIAvatarMultiOrSingle)).apply(this, arguments));
  }

  _createClass(UIAvatarMultiOrSingle, [{
    key: 'makeNumberAvatar',
    value: function makeNumberAvatar() {
      var _props = this.props,
          hasMoreHref = _props.hasMoreHref,
          lookup = _props.lookup,
          maxAvatars = _props.maxAvatars;

      var remainingAvatarsNumber = lookup.length - maxAvatars + 1;
      var remainingAvatarsNumberLimit = remainingAvatarsNumber > 9 ? 9 : remainingAvatarsNumber;
      var remainingAvatars = lookup.slice(-1 * remainingAvatarsNumber);
      var hasMoreAvatarDisplay = remainingAvatarsNumber ? '+' : '';

      return {
        displayName: remainingAvatarsNumberLimit + ' ' + hasMoreAvatarDisplay,
        _isHasMore: true,
        href: hasMoreHref,
        _toolTipOverWrite: this.avatarsToDisplayList(remainingAvatars)
      };
    }
  }, {
    key: 'avatarsToDisplayList',
    value: function avatarsToDisplayList(arrayOfObjects) {
      return arrayOfObjects.map(_pickToolTipName2.default).join(', ');
    }
  }, {
    key: 'renderAvatarList',
    value: function renderAvatarList() {
      var _this2 = this;

      var _props2 = this.props,
          childClassName = _props2.childClassName,
          childStyles = _props2.childStyles,
          className = _props2.className,
          lookup = _props2.lookup,
          maxAvatars = _props2.maxAvatars,
          portalId = _props2.portalId,
          fetchAvatars = _props2.fetchAvatars,
          size = _props2.size;


      var isHiddenAvatars = lookup.length > maxAvatars;
      var newLookupList = isHiddenAvatars ? lookup.slice(0, maxAvatars - 1) : lookup.slice(0);

      if (isHiddenAvatars) {
        newLookupList.push(this.makeNumberAvatar());
      }

      return _react2.default.createElement(
        AvatarListWrapper,
        { className: className },
        newLookupList.reverse().map(function (lookupObj, i) {
          var avatarLookupWithReverse = Object.assign({
            className: childClassName,
            _isListReversed: true,
            portalId: portalId,
            fetchAvatars: fetchAvatars,
            size: size,
            style: childStyles
          }, lookupObj);

          return _this2.renderSingleAvatar(avatarLookupWithReverse, i);
        })
      );
    }
  }, {
    key: 'renderSingleAvatar',
    value: function renderSingleAvatar(props, key) {
      var companyId = props.companyId,
          displayName = props.displayName,
          domain = props.domain,
          email = props.email,
          existsInPortal = props.existsInPortal,
          fetchAvatars = props.fetchAvatars,
          fileManagerKey = props.fileManagerKey,
          hubSpotUserEmail = props.hubSpotUserEmail,
          lookup = props.lookup,
          primaryIdentifier = props.primaryIdentifier,
          secondaryIdentifier = props.secondaryIdentifier,
          socialNetwork = props.socialNetwork,
          src = props.src,
          type = props.type,
          vid = props.vid,
          rest = _objectWithoutProperties(props, ['companyId', 'displayName', 'domain', 'email', 'existsInPortal', 'fetchAvatars', 'fileManagerKey', 'hubSpotUserEmail', 'lookup', 'primaryIdentifier', 'secondaryIdentifier', 'socialNetwork', 'src', 'type', 'vid']);

      var proxyLookup = lookup || {};

      return _react2.default.createElement(_UIAvatarRequest2.default, _extends({
        companyId: companyId || proxyLookup.companyId,
        displayName: displayName || proxyLookup.displayName || email || proxyLookup.email || domain || proxyLookup.domain || secondaryIdentifier || proxyLookup.secondaryIdentifier || primaryIdentifier || proxyLookup.primaryIdentifier,
        domain: domain || proxyLookup.domain,
        email: email || proxyLookup.email,
        existsInPortal: existsInPortal || proxyLookup.existsInPortal,
        fetchAvatars: fetchAvatars,
        fileManagerKey: fileManagerKey || proxyLookup.fileManagerKey,
        hubSpotUserEmail: hubSpotUserEmail || proxyLookup.hubSpotUserEmail,
        key: key,
        primaryIdentifier: primaryIdentifier || proxyLookup.primaryIdentifier,
        socialNetwork: proxyLookup.socialNetwork || socialNetwork,
        secondaryIdentifier: secondaryIdentifier || proxyLookup.secondaryIdentifier,
        src: src || proxyLookup.src,
        type: type || proxyLookup.type,
        vid: vid || proxyLookup.vid
      }, rest));
    }
  }, {
    key: 'render',
    value: function render() {
      var lookup = this.props.lookup;

      if (lookup && Array.isArray(lookup)) {
        return this.renderAvatarList();
      }
      return this.renderSingleAvatar(this.props);
    }
  }]);

  return UIAvatarMultiOrSingle;
}(_react.Component);

var PropTypeChildClassName = function PropTypeChildClassName(props, propName, componentName) {
  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  _react.PropTypes.string.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
  if (props[propName] && !Array.isArray(props.lookup)) {
    return new Error(componentName + ': ' + propName + ' is only applied when lookup is an array.');
  }

  return null;
};

var PropTypeChildStyles = function PropTypeChildStyles(props, propName, componentName) {
  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  _react.PropTypes.string.apply(_react.PropTypes, [props, propName, componentName].concat(rest));

  if (props[propName] && !Array.isArray(props.lookup) && props.lookup.length > 1) {
    return new Error(componentName + ': ' + propName + ' is only applied when lookup is an array that can make children.');
  }

  return null;
};

var PropTypeMaxAvatars = function PropTypeMaxAvatars(props, propName, componentName) {
  if (props[propName] < 2) {
    return new Error(propName + ' needs to be at least 2 in ' + componentName + '.');
  }
  return null;
};

var PropTypeHasMoreHref = function PropTypeHasMoreHref(props, propName, componentName) {
  if (props[propName] && !props.maxAvatars) {
    return new Error(propName + ' will only work if maxAvatars is set in ' + componentName);
  }
  return null;
};

UIAvatarMultiOrSingle.propTypes = _extends({}, _UIAvatarRequest2.default.propTypes, {
  childClassName: PropTypeChildClassName,
  childStyles: PropTypeChildStyles,
  className: _react.PropTypes.string,
  fetchAvatars: _react.PropTypes.func,
  hasMoreHref: PropTypeHasMoreHref,
  lookup: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.array]),
  maxAvatars: PropTypeMaxAvatars,
  portalId: _react.PropTypes.number,
  size: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_SIZES))
});

exports.default = UIAvatarMultiOrSingle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarMultiOrSingle.js
// module id = 976
// module chunks = 2 3